import axios, { AxiosResponse } from 'axios'
import { ServiceDependencies } from 'lib/core/services/magento'
import { getHeaders } from 'lib/core/services/magento/client/utils'

interface ResetPasswordMutationInput {
  payload: {
    resetToken: string
    newPassword: string
    email: string
  }
}

export type ResetPasswordMutation = (input: ResetPasswordMutationInput) => Promise<AxiosResponse<any>>

export const createResetPasswordMutation = (deps: ServiceDependencies): ResetPasswordMutation => async ({ payload }) => {
  return axios.post('/V1/customers/resetPassword', payload, {
    headers: getHeaders()
  })
}
